import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Alert, AppState, Login, Problem } from 'interfaces/app'

const initialState: AppState = {
  isMobile: false,
  alert: { open: false, text: '', status: 0 },
  problem: { open: false, code: '', message: '' },
  login: {
    email: '',
    firstName: '',
    fullName: '',
    identification: '',
    phone: '',
    adviser: '',
    remainingTime: '',
    phoneInput: '',
    emailInput: '',
  },
  urlImmediateSolicitude: '',
  isFirstLoad: true,
}

export const appSlice = createSlice({
  name: 'appStore',
  initialState,
  reducers: {
    setIsMobile: (state, action: PayloadAction<boolean>) => {
      state.isMobile = action.payload
    },
    setAlert: (state, action: PayloadAction<Alert>) => {
      state.alert = action.payload
    },
    setProblem: (state, action: PayloadAction<Problem>) => {
      state.problem = action.payload
    },
    setLogin: (state, action: PayloadAction<Login>) => {
      state.login = action.payload
    },
    setUrlImmediateSolicitude: (state, action: PayloadAction<string>) => {
      state.urlImmediateSolicitude = action.payload
    },
    setFirtsLoad: (state) => {
      state.isFirstLoad = false
    },
  },
})

export const {
  setIsMobile,
  setAlert,
  setProblem,
  setLogin,
  setUrlImmediateSolicitude,
  setFirtsLoad
} = appSlice.actions

export default appSlice.reducer
